import React, { useContext, useState } from 'react'
import { HexColorPicker } from 'react-colorful';
import { BsTypeBold, BsTypeItalic, BsTypeUnderline } from 'react-icons/bs';
import { EditorContext } from '../../../../../../../components/CanvasEditor/Context/EditorProvider';

const FontStyle = () => {

  const { textEditorOptions, setTextEditorOptions } = useContext(EditorContext);
  const [displayColorPalate, setDisplayColorPicker] = useState(false);

  const handleClick = () => {
    setDisplayColorPicker(!displayColorPalate)
  }

  const handleClose = () => {
    setDisplayColorPicker(false)
  };

  const handleChangeWeight = (e) => {
    if (textEditorOptions.fontWeight === 'bold') {
      setTextEditorOptions({ ...textEditorOptions, fontWeight: 'normal' });
    } else {
      setTextEditorOptions({ ...textEditorOptions, fontWeight: 'bold' });
    }
  }

  const handleStroke = (color) => {
    setTextEditorOptions({ ...textEditorOptions, stroke: color });
  }

  const handleTxtStyle = () => {
    if (textEditorOptions.fontStyle === 'italic') {
      setTextEditorOptions({ ...textEditorOptions, fontStyle: 'normal' });
    } else {
      setTextEditorOptions({ ...textEditorOptions, fontStyle: 'italic' });
    }
  }

  const handleTxtDecoration = () => {
    if (textEditorOptions.underline === true) {
      setTextEditorOptions({ ...textEditorOptions, underline: false });
    } else {
      setTextEditorOptions({ ...textEditorOptions, underline: true });
    }
  }

  return (
    <div className='font-style-items'>
      <div className={`item${textEditorOptions.fontWeight === 'bold' ? ' active' : ''}`} onClick={handleChangeWeight} data-toggle="tooltip" data-placement="top" title="Bold">
        <span><BsTypeBold /></span>
      </div>
      <div className={`item${textEditorOptions.fontStyle === 'italic' ? ' active' : ''}`} onClick={handleTxtStyle} data-toggle="tooltip" data-placement="top" title="Italic">
        <span><BsTypeItalic /></span>
      </div>
      <div className={`item${textEditorOptions.underline ? ' active' : ''}`} onClick={handleTxtDecoration} data-toggle="tooltip" data-placement="top" title="Underline">
        <span><BsTypeUnderline /></span>
      </div>
      <div className='item' data-toggle="tooltip" data-placement="top" title="Stroke Color">
        <span onClick={handleClick}>A</span>
        { displayColorPalate ? 
          <div style={{position: 'absolute', zIndex: '2'}}>
            <div style={{position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px'}} onClick={ handleClose }/>
            <HexColorPicker color={textEditorOptions.stroke} onChange={handleStroke} />
          </div> 
          : null 
        }
      </div>
    </div>
  )
}

export default FontStyle